(function () {
    var module = $('.services-pricing-module');
    pricingContact = module.attr('data-pricing-contact');
    pricingTable = module.find('.services-pricing');
    form = module.find('.form');
    doingAjax = false;

    form.find('input[name="pricing-contact-email"]').val(pricingContact);

    pricingTable.find('input[name^="quantity"]').on('input', function () {
        calculateSingleServicePrice($(this));
        calculateTotalPrice();
    });

    $('.button.generate-pricing').on('click', generatePricingPDF);

    function calculateSingleServicePrice(input) {
        var inputVal = input.val();
        singleServiceRow = input.closest('tr');
        calculatedPriceText = singleServiceRow.find('span.calculated-price');
        servicePrice = singleServiceRow.attr('data-singlular-price');
        isIndividual = singleServiceRow.attr('data-individual');

        if (inputVal && inputVal > 0) {
            if (inputVal < 11) {
                var price = inputVal * servicePrice;

                if (!isIndividual) {
                    calculatedPriceText.html(price);
                    singleServiceRow.removeClass('individual');
                }
            } else {
                calculatedPriceText.html('Na zapytanie');
                singleServiceRow.addClass('individual');
            }
            singleServiceRow.addClass('calculated-price');
        } else {
            singleServiceRow.removeClass('calculated-price');
            calculatedPriceText.html('-');

            if (!isIndividual) {
                singleServiceRow.removeClass('individual');
            }
        }

        return false;
    }

    function calculateTotalPrice() {
        var priceSummary = pricingTable.find('span.price-summary');
        priceSummaryRow = priceSummary.closest('tr');
        totalPrice = 0;
        calculatedFieldsIndividual = pricingTable.find(
            '.single-service.calculated-price.individual',
        );
        formPricingContent = form.find('input[name="pricing-content"]');

        if (calculatedFieldsIndividual.length > 0) {
            priceSummary.html('Do ustalenia');
            priceSummaryRow.addClass('total-individual');
            form.fadeIn('fast');
            form.removeClass('special-offer');
            $('.discount-info').slideUp('fast');
            formPricingContent.val(getComputedPricingTableHTML());
            totalPrice = 0;
        } else {
            var totalServices = 0;
            var calculatedFields = pricingTable.find('.single-service.calculated-price');

            for (var i = 0; i < calculatedFields.length; i++) {
                totalPrice += parseInt($(calculatedFields[i]).find('span.calculated-price').html());
                totalServices += parseInt(
                    $(calculatedFields[i]).find('input[type="number"]').val(),
                );
            }

            if (totalPrice > 5000) {
                form.addClass('special-offer');
                form.fadeIn('fast');
            } else {
                form.removeClass('special-offer');
                form.slideUp('fast');
            }

            if (totalServices > 5 && totalServices < 11) {
                totalPrice *= 0.7;
                $('.discount-info').slideDown('fast');
            } else {
                $('.discount-info').slideUp('fast');
            }

            formPricingContent.val('');
            priceSummary.html(totalPrice.toFixed(2));
            priceSummaryRow.removeClass('total-individual');
        }
    }

    function getComputedPricingTableHTML() {
        var content = '';
        tHead = pricingTable.find('thead');
        tBody = pricingTable.find('.single-service.calculated-price');
        tFoot = pricingTable.find('.summary-row');

        content +=
            '<table style="border-collapse: collapse; border: 1px solid #ddd; min-width: 600px; width: 100%; margin-top: 0 !important;">';
        content += tHead[0].outerHTML;
        content += '<tbody>';

        for (var i = 0; i < tBody.length; i++) {
            var row = $(tBody[i]).clone();
            qtyInput = row.find('input[name^="quantity"]');
            quantity = qtyInput.val();

            qtyInput.remove();
            row.find('td.service-quantity').html(quantity);

            if (row.hasClass('individual')) {
                row.find('.currency-symbol').remove();
            }

            content += row[0].outerHTML;
        }

        if (tFoot.hasClass('total-individual')) {
            tFoot = tFoot.clone();
            tFoot.find('.currency-symbol').remove();
        }

        content += tFoot[0].outerHTML;
        content += '</tbody></table>';

        return content;
    }

    function generatePricingPDF(e) {
        var button = $(this);

        if (!doingAjax && !button.hasClass('generated')) {
            e.preventDefault();

            button.removeClass('generated');
            button.addClass('loading');

            const data = {
                action: 'generate_pricing_pdf',
                pricingTable: getComputedPricingTableHTML(),
            };

            $.ajax({
                type: 'POST',
                url: jsData.ajaxUrl,
                data: data,
                success: (response) => {
                    const jsonObject = JSON.parse(response);
                    const pdfUrl = jsonObject.pdfUrl;
                    window.open(pdfUrl, '_blank');

                    response = JSON.parse(response);
                    button.attr('href', response.pdfUrl);
                    button.removeClass('loading');
                    button.addClass('generated');

                    setTimeout(function () {
                        e.target.click();
                        setTimeout(function () {
                            button.removeClass('generated');
                        }, 300);
                    }, 100);
                },
                error: (error) => {
                    console.error(error);
                },
            });
        }
    }
})();
